import React, { Component } from "react";
import { connect } from "react-redux";

import { closeImageModal } from "../../actions/imageModal";
import Modal from "../ui-ant/Feedback/modal";

class ImageModal extends Component {
  componentDidUpdate(prevProps, prevState) {
    const {
      dispatch,
      location: { pathname },
      visible
    } = this.props;
    const {
      location: { pathname: prevPathname }
    } = prevProps;

    if (pathname !== prevPathname && visible) {
      dispatch(closeImageModal());
    }
  }

  render() {
    const { dispatch, visible, image, width, height } = this.props;
    return (
      <Modal
        visible={visible}
        onCancel={() => {
          dispatch(closeImageModal());
        }}
        centered
        width="inherit"
        footer={null}
      >
        <img src={image} width={width} height={height} alt="" />
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    visible: state.imageModal.visible,
    image: state.imageModal.image,
    width: state.imageModal.width,
    height: state.imageModal.height
  };
};

export default connect(mapStateToProps)(ImageModal);



// WEBPACK FOOTER //
// ./src/components/partials/ImageModal.js